export default "__VITE_ASSET__BFB_1N3m__"